export default "__VITE_ASSET__DgygpWC___"